import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { useTranslation } from 'react-i18next'
import { getDateLocaleByLocaleName } from '../../utilities/date'

const ThemeLocalizationProvider = ({ children }) => {
  const { i18n } = useTranslation()

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={getDateLocaleByLocaleName(i18n?.resolvedLanguage || i18n?.language)}
    >
      {children}
    </LocalizationProvider>
  )
}

export default ThemeLocalizationProvider
